import { Injectable } from "@angular/core";
import { BehaviorSubject, Observable, Subject } from "rxjs";
import { TagsApiService } from "./api";
import { debounceTime, switchMap } from "rxjs/operators";
import { TagsDto } from "../dto";
import { LoadingWrapper } from "../decorators";
import { GET_TAG_LOADING_TAG } from "../constants";

@Injectable({
    providedIn: 'root'
})
export class TagService {
    private readonly refreshSubject: Subject<void> = new Subject<void>();
    private readonly tagsSubject: BehaviorSubject<TagsDto[]> = new BehaviorSubject<TagsDto[]>(null);

    constructor(private tagsApiService: TagsApiService) {
        this.refreshSubject.pipe(
            debounceTime(100),
            switchMap(() => this.executeTagsList())
        ).subscribe((res) => {
            this.tagsSubject.next(res);
        });
    }

    getTagsList(): Observable<TagsDto[]> {
        const tags = this.tagsSubject.getValue();

        if (!tags) {
            this.refreshList();
        }

        return this.tagsSubject.asObservable();
    }

    refreshList(): void {
        this.refreshSubject.next();
    }

    @LoadingWrapper(GET_TAG_LOADING_TAG)
    private executeTagsList() {
        return this.tagsApiService.getTagsList();
    }

}
